import { Fragment, useRef, useState, useEffect } from "react";
import { useLocomotiveScroll } from "react-locomotive-scroll";
import { gsap, Sine } from "gsap/all";
import { Link } from "react-router-dom";
import "./Home.scss";
import { Helmet } from "react-helmet";
import Carousel from "./../Carousel/Carousel";

function Home(props) {
  const authCtx = props.authCtx;
  const [activeAppsTab, setActiveAppsTab] = useState(0);
  const [banners, setBanners] = useState([]);
  const [bottom_banners, setBottomBanners] = useState([]);
  const [products, setProducts] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [pressArticles, setPressArticles] = useState([]);
  const [videos, setVideos] = useState([]);
  const appsRef = useRef();
  const boxRef = useRef();
  const soundRef = useRef();
  const latencyRef = useRef();
  const backRef = useRef();
  const recordRef = useRef();
  const awardRef = useRef();
  const contentRef = useRef();
  const fliverTv = useRef();
  const bars = useRef();
  const isMobile = window.matchMedia(
    "only screen and (max-width: 760px)"
  ).matches;

  const { scroll, isReady } = useLocomotiveScroll();

  const makeTabActive = (tab) => {
    setActiveAppsTab(tab);
    gsap.fromTo(
      gsap.utils.selector(appsRef)(".anim"),
      {
        opacity: 0,
        y: 10,
      },
      {
        opacity: 1,
        y: 0,
        stagger: {
          axis: "x",
          amount: 0.5,
        },
      }
    );
  };

  const numberWithCommas = (x) =>
    x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const getBanners = () => {
    fetch(authCtx.baseUrl + "banners")
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setBanners(data);
        console.log(banners);
      });
  };

  const getBottomBanners = () => {
    fetch(authCtx.baseUrl + "bottom_banners")
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setBottomBanners(data);
        console.log(bottom_banners);
      });
  };

  const getProducts = () => {
    fetch(authCtx.baseUrl + "products")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
      });
  };

  const getBlogs = () => {
    fetch(authCtx.baseUrl + "blogs")
      .then((res) => res.json())
      .then((data) => {
        setBlogs(data.slice(0, 3));
      });
  };

  const getPressArticles = () => {
    fetch(authCtx.baseUrl + "press_articles")
      .then((res) => res.json())
      .then((data) => {
        setPressArticles(data.slice(0, 3));
      });
  };

  const getVideos = () => {
    fetch(authCtx.baseUrl + "videos")
      .then((res) => res.json())
      .then((data) => {
        setVideos(data);
      });
  };

  useEffect(() => {
    getBanners();
    getProducts();
    getBlogs();
    getPressArticles();
    getVideos();
    getBottomBanners();
  }, []);

  useEffect(() => {
    if (isReady) {
      const soundQ = gsap.utils.selector(soundRef);
      const latencyQ = gsap.utils.selector(latencyRef);
      const backQ = gsap.utils.selector(backRef);
      const recordQ = gsap.utils.selector(recordRef);
      const awardQ = gsap.utils.selector(awardRef);
      const frameCount = 57,
        canvas = document.querySelector("canvas"),
        context = canvas.getContext("2d"),
        tvSeq = [],
        seq = {
          frame: 0,
        };
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      for (let i = 1; i <= frameCount; i++) {
        const img = new Image();
        img.src = `static/images/frames/tv${i}.png`;
        tvSeq.push(img);
      }
      function canvasRender() {
        const image = tvSeq[seq.frame];
        context.clearRect(0, 0, canvas.width, canvas.height);
        const imgRatio = image.height / image.width;
        const h = window.innerWidth * imgRatio;
        context.drawImage(
          image,
          0,
          (window.innerHeight - h) / 2,
          window.innerWidth,
          h
        );
      }
      let soundAnim = gsap
        .timeline({ paused: true })
        .fromTo(
          soundQ(".tv_wrapper img"),
          { scale: 2, opacity: 0, yPercent: -50 },
          {
            scale: 1,
            opacity: 1,
            yPercent: 0,
            ease: Sine,
          }
        )
        .fromTo(
          soundQ(".tv_wrapper .sound-wave-wrapper"),
          { opacity: 0 },
          {
            opacity: 1,
            ease: Sine,
          }
        )
        .fromTo(
          soundQ(".env_wrapper img"),
          { rotate: -45, yPercent: 50, xPercent: -50, scale: 1.2 },
          {
            rotate: 0,
            yPercent: 0,
            xPercent: 0,
            scale: 1,
            ease: Sine,
          },
          0
        )
        .fromTo(
          soundQ("h1,h2,p,.dolby"),
          { opacity: 0 },
          {
            opacity: 1,
            ease: Sine,
          },
          0
        );
      let latencyAnim = gsap
        .timeline({ paused: true })
        .fromTo(
          latencyQ(".tv"),
          { scale: isMobile ? 1.5 : 2, xPercent: -50, rotateY: -45 },
          {
            scale: 1,
            xPercent: 0,
            rotateY: 0,
            overwrite: true,
            ease: Sine,
          }
        )
        .fromTo(
          latencyQ(".f1"),
          { scale: 0.8, xPercent: -10, opacity: 0 },
          {
            scale: 1,
            opacity: 1,
            xPercent: 0,
            overwrite: true,
            ease: Sine,
          },
          0
        );
      let backAnim = gsap
        .timeline({ paused: true })
        .fromTo(
          backQ(".tv_back_img"),
          { scale: 1.8, xPercent: 100 },
          {
            scale: 1.8,
            xPercent: 50,
            ease: Sine,
          }
        )
        .fromTo(
          backQ("h1,h2"),
          { opacity: 0 },
          {
            opacity: 1,
            ease: Sine,
            duration: 1,
          }
        )
        .fromTo(
          backQ(".tv_back_img"),
          { scale: 1.8, xPercent: 50 },
          {
            scale: 1,
            xPercent: 0,
            ease: Sine,
            delay: -1,
          }
        );
      let contentAnim = gsap.timeline({ paused: true }).fromTo(
        contentRef.current,
        {
          scale: 0.7,
          yPercent: 40,
        },
        {
          scale: 1,
          yPercent: 0,
          ease: Sine,
        },
        0
      );
      let recordNumAnimInit = false;
      let patentsNumAnimInit = false;
      scroll.on("scroll", function (args) {
        if (typeof args.currentElements["comparison"] === "object") {
          let barsRect = bars.current.getBoundingClientRect();
          let w =
            barsRect.x +
            barsRect.width -
            fliverTv.current.getBoundingClientRect().x;
          bars.current.style.width = w + "px";
        }
        if (typeof args.currentElements["boundless"] === "object") {
          let progress = args.currentElements["boundless"].progress;
          seq.frame = Math.round(frameCount * progress);
          canvasRender();
        } else if (typeof args.currentElements["sound"] === "object") {
          let progress = args.currentElements["sound"].progress;
          soundAnim.progress(progress);
        } else if (typeof args.currentElements["latency"] === "object") {
          let progress = args.currentElements["latency"].progress;
          latencyAnim.progress(progress);
        } else if (typeof args.currentElements["back"] === "object") {
          let progress = args.currentElements["back"].progress;

          backAnim.progress(progress);
        } else if (typeof args.currentElements["record"] === "object") {
          if (!recordNumAnimInit) {
            recordNumAnimInit = true;
            gsap.fromTo(
              recordQ(".big"),
              { textContent: 0 },
              {
                textContent: 46272,
                ease: "power1.in",
                duration: 2,
                onUpdate: function () {
                  this.targets()[0].innerHTML = numberWithCommas(
                    Math.ceil(this.targets()[0].textContent)
                  );
                },
              }
            );
          }
        } else if (typeof args.currentElements["content"] === "object") {
          let progress = args.currentElements["content"].progress;
          contentAnim.progress(progress);
        }
        if (typeof args.currentElements["award"] === "object") {
          if (!patentsNumAnimInit) {
            patentsNumAnimInit = true;
            console.log("animating");
            gsap.fromTo(
              awardQ(".number"),
              {
                textContent: 0,
              },
              {
                textContent: function (_, target) {
                  return target.dataset.number;
                },
                ease: "power1.in",
                duration: 2,
                stagger: {
                  each: 0.1,
                  onUpdate: function () {
                    this.targets()[0].innerHTML = Math.ceil(
                      this.targets()[0].textContent
                    );
                  },
                },
              }
            );
          }
        }
      });
    }
  }, [scroll]);

  return (
    <Fragment>
      <Helmet>
        <title>
          Coocaa Smart Televisions- Buy Latest Televisions Online at the Best
          Price
        </title>
        <meta
          name="description"
          content="Shop for top quality Full HD TV's online - The best TV brand of India is here. Choose from a wide range of Smart LED TV, Android TV & 4K TVs."
        />
        <meta
          name="keywords"
          content="coocaa, coocaa tv, coocaa smart tv, one plus tv 32, tv,television, tv's under 10000,tv's under 20000,best led tv, lg led tv, best smart tv, smart tv 32 inch
    android tv price,led tv price in india, best android tv in india, smart tv price 32 inch,4k led tv,smart tv full hd, flipkart led tv, best 50 inch tv, 55 inch led tv,
    best smart tv in India"
        />
      </Helmet>

      <section className="hero_banner">
        <Carousel slides={banners} height="58vw"></Carousel>
      </section>

      <div className="top_card_wrapper" data-scroll data-scroll-speed="2">
        <div className="top_card">
          {/* <div className="discover">
            <img data-scroll src="static/images/discover.png" alt="" />
            <img className="l1" src="static/images/discover_l1.png" alt="" />
          </div> */}
          Unlimited Enjoyment <span className="primary_color">for all</span>
        </div>
      </div>

      <section id="androidTv" className="pt-20 sm:pt-40 sm:pt-52 pb-20">
        <div className="px-5 sm:px-20 2xl:px-32">
          <h1 className="heading">
            {/* Android 11&nbsp; */}
            Google&nbsp;
            <span className="primary_color">
              TV
              {/* <sup>TM</sup>{" "} */}
            </span>
          </h1>
          {/* <h2 className="sub_heading">
            The Coocaa TV is built on the latest Google TV platform
          </h2> */}
          <p className="copy">
            All the content that you love, exactly how you want it. Welcome to a
            smarter way to watch.
          </p>
        </div>
        <div className="android_tv_wrapper px-5 sm:px-20 2xl:px-32 py-14">
          <img
            src="static/images/android_tv.png"
            data-scroll
            data-scroll-speed={isMobile ? "-2" : "-3"}
          />
          <div className="atv_copy">
            <span className="icon">
              <img
                aria-hidden="true"
                alt="Google Assistant"
                src="static/images/google-assistant_1x.png"
                srcSet="static/images/google-assistant_2x.png 2x"
                height="32"
                width="32"
              />
            </span>
            <h2 className="atv_heading">Now playing: Your Google Assistant</h2>
            <p className="atv_description">
              Android TV now comes with your Google Assistant built in. Just say
              “Ok Google” or press the mic button on your remote to quickly find
              the latest blockbuster, check the score of the big game or dim the
              lights - all without leaving what you're watching.
            </p>
          </div>
          <div ref={appsRef} className="apps_wrapper mt-28 sm:mt-40">
            <div className="tabs">
              <div
                style={{
                  transform: "translateX(" + activeAppsTab * 100 + "%)",
                }}
                className="active_bar"
              ></div>
              <div
                className="tab"
                onClick={() => {
                  makeTabActive(0);
                }}
              >
                STREAMING
              </div>
              <div
                className="tab"
                onClick={() => {
                  makeTabActive(1);
                }}
              >
                LIVE TV
              </div>
              <div
                className="tab"
                onClick={() => {
                  makeTabActive(2);
                }}
              >
                APPS & GAMES
              </div>
            </div>
            <div className="anim">
              {activeAppsTab == 0 ? (
                <div className="apps">
                  <div className="app">
                    <img src="static/images/apps/disneyplus.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/mxplayer.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/netflix.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/youtube.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/primevideo.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/appletv.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/zee5.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/sonyliv.png" alt="" />
                  </div>
                </div>
              ) : activeAppsTab == 1 ? (
                <div className="apps">
                  <div className="app">
                    <img src="static/images/apps/yupptv.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/voot.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/jiotv.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/hotstar.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/youtubetv.png" alt="" />
                  </div>
                </div>
              ) : (
                <div className="apps">
                  <div className="app">
                    <img src="static/images/apps/asphalt.png" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/badland.jpg" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/minion.jpg" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/bombsquad.jpg" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/crossyroad.jpg" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/skyforce.jpg" alt="" />
                  </div>
                  <div className="app">
                    <img src="static/images/apps/beachbuggy.jpg" alt="" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* eye care */}
      <section
        id="eyeCare"
        ref={boxRef}
        data-scroll
        data-scroll-speed="-1"
        data-scroll-direction={isMobile ? "vertical" : "horizontal"}
        className="sm:px-20 2xl:px-32 py-10 sm:py-20 sm:my-32 sm:mr-32"
      >
        <div className="wrapper">
          {/* <svg
            width="216"
            height="93"
            viewBox="0 0 216 93"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.7031 61.4844V65H4.00781V33.0078H24.2578V36.5234H8.01562V46.6953H20.9062V49.9531H8.01562V61.4844H24.7031ZM51.2578 33.0078L40.5469 51.5469V65H36.5391V51.5469L25.8281 33.0078H30.5391L39.0469 47.7266L47.6016 33.0078H51.2578ZM75.5156 61.4844V65H54.8203V33.0078H75.0703V36.5234H58.8281V46.6953H71.7188V49.9531H58.8281V61.4844H75.5156ZM112.289 54.2422L115.945 55.0625C114.195 62.1094 110.242 65.6328 104.086 65.6328C100.039 65.6328 96.8594 64 94.5469 60.7344C92.25 57.4688 91.1016 53.4531 91.1016 48.6875C91.1016 43.7656 92.3047 39.8125 94.7109 36.8281C97.1172 33.8438 100.344 32.3516 104.391 32.3516C110.391 32.3516 114.242 35.7812 115.945 42.6406L112.172 43.3906C110.797 38.2969 108.195 35.75 104.367 35.75C101.539 35.75 99.3438 36.9375 97.7812 39.3125C96.2344 41.6719 95.4609 44.9922 95.4609 49.2734C95.4609 53.1953 96.2578 56.3438 97.8516 58.7188C99.4453 61.0781 101.555 62.2578 104.18 62.2578C108.258 62.2578 110.961 59.5859 112.289 54.2422ZM142.453 65H138.352L135.117 55.6484H123.281L120.422 65H117.07L127.453 33.0078H132.023L142.453 65ZM134.273 52.6484L129.352 37.2734L124.383 52.6484H134.273ZM169.664 65H165.469L159.562 51.1484H150.398V65H146.648V33.0078H159.258C162.68 33.0078 165.211 33.9453 166.852 35.8203C168.508 37.6797 169.336 39.7188 169.336 41.9375C169.336 43.6406 168.875 45.2734 167.953 46.8359C167.031 48.3984 165.508 49.5156 163.383 50.1875L169.664 65ZM150.398 47.8906H158.766C160.969 47.8906 162.609 47.3125 163.688 46.1562C164.781 44.9844 165.328 43.5547 165.328 41.8672C165.328 40.1797 164.75 38.8672 163.594 37.9297C162.453 36.9922 161.008 36.5234 159.258 36.5234H150.398V47.8906ZM196.781 61.4844V65H176.086V33.0078H196.336V36.5234H180.094V46.6953H192.984V49.9531H180.094V61.4844H196.781Z"
              fill="#313131"
            />
            <path
              d="M4.00781 88H2.00391V72.0039H11.8008V73.7617H4.00781V78.8125H10.4648V80.4297H4.00781V88ZM28.1967 86.2422V88H18.7514V72.0039H20.8022V86.2422H28.1967ZM37.0809 88H35.077V72.0039H37.0809V88ZM55.223 82.6211L57.0511 83.0312C56.1761 86.5547 54.1995 88.3164 51.1214 88.3164C49.098 88.3164 47.5081 87.5 46.3519 85.8672C45.2034 84.2344 44.6292 82.2266 44.6292 79.8438C44.6292 77.3828 45.2308 75.4062 46.4339 73.9141C47.637 72.4219 49.2503 71.6758 51.2738 71.6758C54.2738 71.6758 56.1995 73.3906 57.0511 76.8203L55.1644 77.1953C54.4769 74.6484 53.1761 73.375 51.262 73.375C49.848 73.375 48.7503 73.9688 47.9691 75.1562C47.1956 76.3359 46.8089 77.9961 46.8089 80.1367C46.8089 82.0977 47.2073 83.6719 48.0042 84.8594C48.8011 86.0391 49.8558 86.6289 51.1683 86.6289C53.2073 86.6289 54.5589 85.293 55.223 82.6211ZM76.74 88H74.5486L69.7673 79.1758L66.0994 83.7344V88H64.0955V72.0039H66.0994V81.2852L73.3298 72.0039H75.4978L71.1619 77.6055L76.74 88ZM94.0969 86.2422V88H83.7492V72.0039H93.8742V73.7617H85.7531V78.8477H92.1984V80.4766H85.7531V86.2422H94.0969ZM112.965 88H110.868L107.915 81.0742H103.333V88H101.458V72.0039H107.762C109.473 72.0039 110.739 72.4727 111.559 73.4102C112.387 74.3398 112.801 75.3594 112.801 76.4688C112.801 77.3203 112.571 78.1367 112.11 78.918C111.649 79.6992 110.887 80.2578 109.825 80.5938L112.965 88ZM103.333 79.4453H107.516C108.618 79.4453 109.438 79.1562 109.977 78.5781C110.524 77.9922 110.798 77.2773 110.798 76.4336C110.798 75.5898 110.508 74.9336 109.93 74.4648C109.36 73.9961 108.637 73.7617 107.762 73.7617H103.333V79.4453ZM133.3 88H131.296V72.0039H141.093V73.7617H133.3V78.8125H139.757V80.4297H133.3V88ZM159.552 88H157.454L154.501 81.0742H149.919V88H148.044V72.0039H154.349C156.06 72.0039 157.325 72.4727 158.145 73.4102C158.974 74.3398 159.388 75.3594 159.388 76.4688C159.388 77.3203 159.157 78.1367 158.696 78.918C158.235 79.6992 157.474 80.2578 156.411 80.5938L159.552 88ZM149.919 79.4453H154.102C155.204 79.4453 156.024 79.1562 156.563 78.5781C157.11 77.9922 157.384 77.2773 157.384 76.4336C157.384 75.5898 157.095 74.9336 156.517 74.4648C155.946 73.9961 155.224 73.7617 154.349 73.7617H149.919V79.4453ZM177.67 86.2422V88H167.323V72.0039H177.448V73.7617H169.327V78.8477H175.772V80.4766H169.327V86.2422H177.67ZM195.379 86.2422V88H185.031V72.0039H195.156V73.7617H187.035V78.8477H193.48V80.4766H187.035V86.2422H195.379Z"
              fill="#313131"
            />
            <path
              d="M202.694 33H201.615V25.2876H199.133V24.3354H205.183V25.2876H202.694V33ZM214.761 33H213.708V25.4336L210.889 33H210.153L207.315 25.4336V33H206.395V24.3354H208.007L210.616 31.2671L213.174 24.3354H214.761V33Z"
              fill="#313131"
            />
            <g clipPath="url(#clip0_200_640)">
              <path
                d="M16.793 18.4636C15.8359 19.1634 14.7266 19.6263 13.5559 19.8143C12.3852 20.0023 11.1867 19.91 10.0586 19.545C8.93056 19.18 7.90511 18.5527 7.06644 17.7147C6.22776 16.8766 5.59977 15.8516 5.234 14.7237C4.86824 13.5959 4.77511 12.3974 4.96227 11.2267C5.14944 10.0559 5.61155 8.94615 6.3107 7.98857C7.00984 7.03099 7.92609 6.25285 8.98424 5.71799C10.0424 5.18313 11.2123 4.90681 12.3979 4.9117C13.9772 4.90703 15.5168 5.40614 16.793 6.33646C17.3216 6.69352 17.9683 6.8311 18.5964 6.72016C19.2246 6.60921 19.785 6.25843 20.1592 5.74191C20.5335 5.22539 20.6923 4.58361 20.6021 3.95215C20.5119 3.3207 20.1798 2.74904 19.6759 2.35796C18.0918 1.20917 16.2583 0.451533 14.3253 0.146978C12.3923 -0.157577 10.4147 -0.000408587 8.55403 0.605637C6.69341 1.21168 5.0026 2.24941 3.6198 3.63399C2.237 5.01857 1.20146 6.71071 0.597804 8.57211C-0.00584629 10.4335 -0.160469 12.4113 0.146573 14.3439C0.453616 16.2765 1.21361 18.1091 2.36444 19.6917C3.51526 21.2744 5.02426 22.5622 6.76809 23.4501C8.51193 24.3379 10.4411 24.8005 12.3979 24.8001C15.0146 24.8064 17.5653 23.979 19.6801 22.4379C20.1797 22.045 20.5076 21.4738 20.5951 20.8442C20.6825 20.2147 20.5227 19.5757 20.1491 19.0614C19.7756 18.5472 19.2173 18.1976 18.5916 18.0862C17.9658 17.9747 17.3212 18.11 16.793 18.4636Z"
                fill="#313131"
              />
              <path
                d="M92.5387 18.4636C91.5816 19.1634 90.4722 19.6263 89.3016 19.8143C88.1309 20.0023 86.9324 19.91 85.8043 19.545C84.6763 19.18 83.6508 18.5527 82.8121 17.7146C81.9735 16.8766 81.3455 15.8515 80.9797 14.7237C80.6139 13.5959 80.5208 12.3974 80.708 11.2267C80.8951 10.0559 81.3573 8.94615 82.0564 7.98857C82.7555 7.03099 83.6718 6.25284 84.7299 5.71799C85.7881 5.18313 86.958 4.90681 88.1436 4.9117C89.7217 4.90647 91.2602 5.40567 92.5346 6.33646C92.7956 6.52968 93.0923 6.66926 93.4076 6.74714C93.7228 6.82502 94.0504 6.83965 94.3714 6.79019C94.6923 6.74073 95.0003 6.62815 95.2775 6.45897C95.5547 6.28979 95.7956 6.06735 95.9863 5.80452C96.1771 5.54168 96.3138 5.24365 96.3887 4.92766C96.4636 4.61166 96.4751 4.28396 96.4226 3.96348C96.3701 3.64301 96.2546 3.33612 96.0828 3.06055C95.9109 2.78497 95.6862 2.54618 95.4216 2.35796C93.8375 1.20917 92.004 0.451533 90.071 0.146978C88.138 -0.157577 86.1604 -0.000408588 84.2997 0.605637C82.4391 1.21168 80.7483 2.24941 79.3655 3.63399C77.9827 5.01857 76.9472 6.71071 76.3435 8.57211C75.7398 10.4335 75.5852 12.4113 75.8923 14.3439C76.1993 16.2765 76.9593 18.109 78.1101 19.6917C79.261 21.2744 80.77 22.5622 82.5138 23.4501C84.2576 24.3379 86.1868 24.8005 88.1436 24.8C90.7592 24.8072 93.3088 23.9797 95.4216 22.4379C95.9486 22.0557 96.3022 21.4797 96.4045 20.8367C96.5069 20.1937 96.3496 19.5364 95.9673 19.0093C95.585 18.4823 95.009 18.1287 94.3661 18.0264C93.7231 17.924 93.0658 18.0813 92.5387 18.4636Z"
                fill="#313131"
              />
              <path
                d="M137.602 1.70833e-06C135.633 -0.00103156 133.693 0.466671 131.94 1.36443C130.188 2.26218 128.675 3.56419 127.526 5.16277C126.376 6.76135 125.624 8.61057 125.331 10.5575C125.039 12.5044 125.213 14.493 125.842 16.3589C126.47 18.2248 127.533 19.9144 128.944 21.2879C130.354 22.6613 132.072 23.6792 133.954 24.2574C135.836 24.8355 137.828 24.9573 139.767 24.6127C141.705 24.2681 143.533 23.4669 145.101 22.2755V22.3379C145.087 22.669 145.141 22.9993 145.258 23.3092C145.375 23.619 145.554 23.9019 145.783 24.141C146.013 24.38 146.288 24.5702 146.593 24.7001C146.898 24.8301 147.225 24.897 147.557 24.897C147.888 24.897 148.216 24.8301 148.521 24.7001C148.825 24.5702 149.101 24.38 149.33 24.141C149.559 23.9019 149.738 23.619 149.855 23.3092C149.973 22.9993 150.026 22.669 150.013 22.3379V12.3979C150.009 9.10865 148.7 5.95522 146.373 3.63051C144.046 1.30581 140.891 4.04205e-08 137.602 1.70833e-06ZM137.602 19.8884C136.119 19.8884 134.669 19.4486 133.436 18.6246C132.203 17.8006 131.242 16.6295 130.674 15.2593C130.107 13.889 129.958 12.3813 130.247 10.9267C130.537 9.47205 131.251 8.1359 132.3 7.08719C133.348 6.03847 134.685 5.32428 136.139 5.03494C137.594 4.7456 139.101 4.8941 140.472 5.46166C141.842 6.02922 143.013 6.99036 143.837 8.22352C144.661 9.45668 145.101 10.9065 145.101 12.3896C145.101 14.3784 144.311 16.2857 142.904 17.692C141.498 19.0983 139.591 19.8884 137.602 19.8884Z"
                fill="#313131"
              />
              <path
                d="M110.077 1.70833e-06C108.109 -0.00103156 106.168 0.466671 104.416 1.36443C102.664 2.26218 101.15 3.56419 100.001 5.16277C98.8518 6.76135 98.0997 8.61057 97.8068 10.5575C97.514 12.5044 97.6889 14.493 98.317 16.3589C98.9452 18.2248 100.008 19.9144 101.419 21.2879C102.83 22.6613 104.547 23.6792 106.429 24.2574C108.311 24.8355 110.304 24.9573 112.242 24.6127C114.18 24.2681 116.009 23.4669 117.576 22.2755V22.3379C117.563 22.669 117.616 22.9993 117.733 23.3092C117.851 23.619 118.029 23.9019 118.259 24.141C118.488 24.38 118.763 24.5702 119.068 24.7001C119.373 24.8301 119.701 24.897 120.032 24.897C120.363 24.897 120.691 24.8301 120.996 24.7001C121.301 24.5702 121.576 24.38 121.805 24.141C122.035 23.9019 122.214 23.619 122.331 23.3092C122.448 22.9993 122.502 22.669 122.488 22.3379V12.3979C122.485 9.10865 121.176 5.95522 118.849 3.63051C116.522 1.30581 113.367 4.04205e-08 110.077 1.70833e-06ZM110.077 19.8884C108.594 19.8884 107.145 19.4486 105.911 18.6246C104.678 17.8006 103.717 16.6295 103.15 15.2593C102.582 13.889 102.433 12.3813 102.723 10.9267C103.012 9.47205 103.726 8.1359 104.775 7.08719C105.824 6.03847 107.16 5.32428 108.615 5.03494C110.069 4.7456 111.577 4.8941 112.947 5.46166C114.317 6.02922 115.488 6.99036 116.312 8.22352C117.136 9.45668 117.576 10.9065 117.576 12.3896C117.576 14.3784 116.786 16.2857 115.38 17.692C113.974 19.0983 112.066 19.8884 110.077 19.8884Z"
                fill="#313131"
              />
              <path
                d="M46.4839 12.3979C46.4848 14.851 45.7581 17.2492 44.3958 19.2893C43.0336 21.3294 41.0969 22.9196 38.8308 23.8589C36.5647 24.7983 34.0709 25.0445 31.6648 24.5664C29.2588 24.0883 27.0486 22.9075 25.3137 21.1732C23.5788 19.4389 22.3972 17.229 21.9183 14.8232C21.4395 12.4173 21.6848 9.92342 22.6234 7.65698C23.5619 5.39055 25.1515 3.45337 27.1912 2.09042C29.2308 0.727476 31.6287 1.38396e-07 34.0818 0C37.3703 -1.85529e-07 40.5242 1.30607 42.85 3.63102C45.1757 5.95596 46.4828 9.10942 46.4839 12.3979ZM34.0818 4.96167C32.6101 4.96167 31.1714 5.39815 29.9477 6.2159C28.724 7.03365 27.7704 8.19593 27.2074 9.55574C26.6443 10.9155 26.4972 12.4118 26.7847 13.8552C27.0721 15.2986 27.7811 16.6244 28.8221 17.6647C29.8631 18.7051 31.1892 19.4134 32.6328 19.7001C34.0764 19.9867 35.5726 19.8387 36.932 19.275C38.2915 18.7112 39.4533 17.7569 40.2703 16.5327C41.0874 15.3086 41.5231 13.8697 41.5223 12.3979C41.5211 10.4253 40.7368 8.5339 39.3415 7.13945C37.9463 5.745 36.0544 4.96167 34.0818 4.96167Z"
                fill="#313131"
              />
              <path
                d="M73.5128 12.3979C73.5136 14.8512 72.7868 17.2496 71.4244 19.2897C70.0619 21.3299 68.125 22.9201 65.8587 23.8593C63.5923 24.7985 61.0983 25.0445 58.6922 24.5661C56.286 24.0877 54.0758 22.9064 52.3411 21.1717C50.6063 19.437 49.4251 17.2268 48.9467 14.8206C48.4683 12.4144 48.7142 9.92045 49.6534 7.6541C50.5926 5.38774 52.1829 3.45084 54.223 2.0884C56.2632 0.725952 58.6616 -0.000823232 61.1148 6.99782e-07C64.4026 0.00110491 67.5554 1.30767 69.8803 3.63249C72.2051 5.95731 73.5117 9.11014 73.5128 12.3979ZM61.1148 4.96167C59.6429 4.96085 58.2038 5.39663 56.9796 6.21388C55.7554 7.03112 54.8011 8.19312 54.2374 9.55285C53.6737 10.9126 53.526 12.4089 53.813 13.8526C54.1 15.2963 54.8087 16.6225 55.8495 17.6633C56.8903 18.7041 58.2164 19.4128 59.6601 19.6998C61.1038 19.9867 62.6002 19.839 63.9599 19.2754C65.3196 18.7117 66.4816 17.7574 67.2989 16.5332C68.1161 15.309 68.5519 13.8699 68.5511 12.3979C68.5511 10.4257 67.7676 8.53427 66.3731 7.1397C64.9785 5.74513 63.087 4.96167 61.1148 4.96167Z"
                fill="#313131"
              />
            </g>
            <defs>
              <clipPath id="clip0_200_640">
                <rect width="150" height="24.8" fill="white" />
              </clipPath>
            </defs>
          </svg> */}
          <h1 className="heading mt-5 sm:mt-10 mb-2">
            Flicker <span className="primary_color">Free!</span>
          </h1>
          <div className="copy mx-auto mb-10 sm:mb-20">
            By controlling the current output to adjust the screen brightness,
            so that the screen brightness changes smoothly, without any
            flickering. This way, the backlight has no flash and is healthier
            for our eyes.
          </div>
          <div
            className="comparision_wrapper"
            data-scroll
            data-scroll-id="comparison"
          >
            <div className="tv1">
              <img
                src="static/images/tv.png"
                data-scroll
                data-scroll-speed={isMobile ? "-1" : "-2"}
                data-scroll-direction="horizontal"
              />
            </div>
            <div className="tv2">
              <img
                ref={fliverTv}
                src="static/images/flicker-tv.png"
                data-scroll
                data-scroll-speed={isMobile ? "1" : "2"}
                data-scroll-direction="horizontal"
              />
            </div>
            <div className="phone_wrapper">
              <div className="phone" data-scroll data-scroll-speed="1">
                <img src="static/images/phone.png" />
                <div className="bars" ref={bars}>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* boundless */}
      <section
        id="boundless"
        data-scroll
        data-scroll-speed={isMobile ? "0" : "0.1"}
        data-scroll-direction="horizontal"
        data-scroll-id="boundless"
      >
        <div
          className="sticky_wrapper px-5 sm:px-20 2xl:px-32 py-20 sm:ml-32 sm:-mr-32"
          data-scroll
          data-scroll-sticky
          data-scroll-target="#boundless"
        >
          {/* <h2 className="sub_heading">Infinity screen</h2> */}
          <h1 className="heading my-5">
            Boundless <span className="primary_color">Screen</span>
          </h1>
          <div className="copy mx-auto sm:mb-10">
            Boundless full-screen design, ingenious craftsmanship to create the
            ultimate slim linear middle frame, tightly fit the edge of the
            screen, bringing you boundless visual enjoyment.
          </div>
          <div className="tv_wrapper">
            {/* <img src="static/images/boundless.png" /> */}
            <canvas></canvas>
          </div>
        </div>
      </section>

      <section id="privacy">
        <img src="static/images/privacy.png" alt="" />
        <img
          data-scroll
          data-scroll-speed={isMobile ? "-1" : "-2"}
          className="l1"
          src="static/images/privacy_l1.png"
          alt=""
        />
        <div className="content_wrapper pb-10 sm:pb-20 px-5 sm:px-20 2xl:px-32">
          <div className="copy">
            <h1 className="heading">A family</h1>
            <h1 className="heading">gurdian of privacy</h1>
          </div>
        </div>
      </section>

      {/* sound */}
      <section
        id="sound"
        data-scroll
        data-scroll-speed={isMobile ? "0" : "0.1"}
        data-scroll-direction="horizontal"
        data-scroll-id="sound"
      >
        <div
          data-scroll
          data-scroll-sticky
          data-scroll-target="#sound"
          className="sticky_wrapper sm:px-20 2xl:px-32 sm:pt-20 sm:my-24 sm:ml-32 sm:-mr-32"
          ref={soundRef}
        >
          <div className="tv_wrapper">
            <img src="static/images/sound.png" alt="" />
            <div className="sound-wave-wrapper active">
              <div className="sound-wave sound-wave-left">
                <div className="sound-wave-circle sound-wave-circle-1"></div>
                <div className="sound-wave-circle sound-wave-circle-2"></div>
                <div className="sound-wave-circle sound-wave-circle-3"></div>
              </div>
              <div className="sound-wave sound-wave-right">
                <div className="sound-wave-circle sound-wave-circle-1"></div>
                <div className="sound-wave-circle sound-wave-circle-2"></div>
                <div className="sound-wave-circle sound-wave-circle-3"></div>
              </div>
            </div>
          </div>
          <img src="static/images/dolby.png" alt="" className="dolby" />
          <h2 className="sub_heading">Enhanced surround sound</h2>
          <h1 className="heading">
            Give your ears <span className="primary_color">a treat</span>
          </h1>
          <p>
            With Dolby Audio&DTS StudioSound, TV can truly restore surround
            sound, Which brings you a theater viewing experience at home.
          </p>
          <div className="env_wrapper mt-10 sm:mt-20">
            <img src="static/images/sound_env.png" alt="" />
          </div>
        </div>
      </section>

      {/* latency */}
      <section
        id="latency"
        data-scroll
        data-scroll-speed="-0.1"
        data-scroll-direction="horizontal"
        data-scroll-id="latency"
      >
        <div
          className="sticky_wrapper"
          data-scroll
          data-scroll-sticky
          data-scroll-target="#latency"
        >
          <div
            className="content_wrapper pt-20 sm:pt-0 pr-5 sm:pr-32 sm:ml-32"
            ref={latencyRef}
          >
            <div className="tv_wrapper">
              <img className="tv" src="static/images/latency.png" alt="" />
              <img className="f1" src="static/images/latency_f1.png" alt="" />
            </div>
            <div className="col">
              <h2 className="sub_heading">Game Mode</h2>
              <h1 className="heading my-2 mb-4">
                Low Latency
                <span className="primary_color">Fast Response</span>
              </h1>
              <p>
                Adopting HDMI 2.0b low-latency technology makes the image much
                smoother when playing games, which can minimize game operation
                delay.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* content */}
      <section
        id="content"
        data-scroll
        data-scroll-id="content"
        className="px-5 sm:px-20 2xl:px-32 pt-24"
      >
        <div
          className="sticky_wrapper"
          data-scroll
          data-scroll-sticky
          data-scroll-target="#content"
        >
          <h2>Massive Content Perfect Audiovisual Experience </h2>
          <h1 className="heading">
            Unlimited <span className="primary_color">Content</span>
          </h1>
          <p>
            Coocaa TV's has YouTube,Netflix,Prime Video etc. built in, and
            unlimited of APPs and contents can be installed at will.
          </p>
          <div className="tv_wrapper mt-10">
            <img ref={contentRef} src="static/images/apps.png" alt="" />
          </div>
        </div>
      </section>

      {/* casting */}
      <section id="casting" className="pr-5 sm:pr-32 sm:pt-20 sm:mb-32 mt-64">
        <div className="tv_wrapper">
          <img
            data-scroll
            data-scroll-speed="1.5"
            src="static/images/cast_tv.png"
            alt=""
          />
        </div>
        <div className="col">
          <h2>TV Casting</h2>
          <h1 className="heading mt-2 mb-6">
            Chromecast <span className="primary_color">Built-in</span>
          </h1>
          <p>
            There are two ways to cast photos,videos from your mobile to the TV
            screen, Chromecast and CastPlay. You can share the entertainment
            with your family at home.
          </p>
          <img
            data-scroll
            data-scroll-speed="1"
            data-scroll-direction="horizontal"
            className="mobile"
            src="static/images/cast_mobile.png"
            alt=""
          />
        </div>
      </section>

      <section id="chameleon">
        <div className="l2">
          <img src="static/images/chameleon_logo.png" alt="" />
          <h1>Chameleon Extreme 2.0</h1>
          <h1>See the Real World</h1>
          <p>
            Chameleon Extrem 2.0 image quality processing engine can optimize TV
            images quality multidimensionally.Let you see the real nature.
          </p>
        </div>
        <img className="chameleon" src="static/images/chameleon.png" alt="" />
        <div className="l1">
          <img
            data-scroll
            data-scroll-speed={isMobile ? "-0.5" : "-1"}
            src="static/images/chameleon_l1.png"
            alt=""
          />
        </div>
      </section>

      <section id="back" data-scroll data-scroll-id="back">
        <div
          data-scroll
          data-scroll-sticky
          data-scroll-target="#back"
          className="sticky_wrapper px-5 sm:px-20 2xl:px-32 pt-20 sm:mb-32 sm:ml-32"
          ref={backRef}
        >
          <h1 className="heading">
            Metal <span className="primary_color">Back Cover</span>
          </h1>
          <h2 className="sub_heading">Multiple Connectivity & Ports</h2>
          <img className="tv_back_img" src="static/images/back_0722.png" alt="" />
        </div>
      </section>

      {/* remote */}
      <section
        id="remote"
        className="px-5 sm:px-20 2xl:px-32 pt-20 sm:pt-0 pb-10 sm:pb-0 my-16 sm:my-32 sm:my-64"
      >
        <div className="remote_wrapper">
          <img
            data-scroll
            data-scroll-speed="1"
            src="static/images/remote_0722.png"
            alt=""
          />
          <img
            data-scroll
            data-scroll-speed="-1"
            className="l1"
            src="static/images/remote_l1_0722.png"
            alt=""
          />
        </div>
        <div className="col">
          <h1 className="heading">All-In-One</h1>
          <h1 className="heading">
            <span className="primary_color">Smart Remote</span>
          </h1>
          <p className="my-10">
            {/* The Coocaa Smart TV comes with an equally smart companion - the
            smart TV remote. With its ergonomic curved & slim design and precise
            weight distribution, it offers a comfortable grip and is a pleasure
            to use. */}
            The Google TV by Coocaa comes with an exceptionally smart remote.
            With its ergonomic curved & slim design and precise weight
            distribution, it offers a comfortable grip and is a pleasure to use.
          </p>
          <Link to="/products/accessories">
            <button>SHOP IN ACCESSORIES</button>
          </Link>
        </div>
      </section>

      {/* record */}
      <section
        id="record"
        ref={recordRef}
        data-scroll
        data-scroll-id="record"
        className="px-5 sm:px-20 2xl:px-32 py-20 sm:my-32 sm:ml-32"
      >
        <div className="map_wrapper">
          <img src="static/images/map.png" alt="" />
        </div>
        <img className="guinesss" src="static/images/guiness.png" alt="" />
        <div className="col">
          <img src="static/images/cooca-official.png" alt="" />
          <h5 className="mb-10">
            AFF Suzuki Cup 2020 <br /> Official Smart TV
          </h5>
          <h3>
            SOLD <span className="big">46272</span> UNITS
          </h3>
          <h3>ON A SINGLE DAY</h3>
          <h1 className="mt-4">GUINNESS WORLD RECORDS</h1>
          <p>The world's leading OTT TV brand</p>
        </div>
        <div className="tv_wrapper">
          <img src="static/images/record.png" alt="" />
          <img
            data-scroll
            data-scroll-speed={isMobile ? "0.5" : "1"}
            data-scroll-direction="horizontal"
            className="l1"
            src="static/images/record_l1.png"
            alt=""
          />
        </div>
      </section>

      {/* award */}
      <section
        data-scroll
        data-scroll-id="award"
        ref={awardRef}
        id="award"
        className="px-5 sm:px-20 2xl:px-32 py-20 my-32"
      >
        <h1>GLOBAL RECOGNITION & INDUSTRIAL AWARD</h1>
        <p>25 Global Design Awards Global Top 7 Design Centre</p>
        <div className="stats_row mt-14 mb-20">
          <div className="col">
            <div className="number" data-number="5166">
              5166
            </div>
            <p>Applied for patents</p>
          </div>
          <div className="col">
            <div className="number" data-number="968">
              968
            </div>
            <p>Invention patents</p>
          </div>
          <div className="col">
            <div className="number" data-number="1326">
              1326
            </div>
            <p>Invention patents</p>
          </div>
          <div className="col">
            <div className="number" data-number="833">
              833
            </div>
            <p>Design patents</p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <img src="static/images/red-dot.png" alt="" />
            <p>2018 Design Award from AWE 2017 Red-dot Design Award</p>
          </div>
          <img
            data-scroll
            data-scroll-speed="1"
            data-scroll-direction="horizontal"
            src="static/images/award.png"
            alt=""
          />
        </div>
      </section>

      <section id="specs" className="sm:px-20 2xl:px-32 sm:pb-40 sm:ml-32">
        <h1 className="heading px-5 sm:px-0">
          Technical <span className="primary_color">Specs</span>
        </h1>
        <div className="carousel mt-10">
          {products.map((tv) => (
            <Link to={tv.slug} className="carousel_card" key={tv.id}>
              <img src={tv.image} alt="" />
              <h2>{tv.name}</h2>
              <h3>MODEL : {tv.model}</h3>
              <ul>
                {tv.featured_specs?.split(",").map((li, i) => (
                  <li key={i}>{li}</li>
                ))}
              </ul>
              <button>BUY NOW</button>
            </Link>
          ))}
        </div>
      </section>

      <section id="bottomCarousel">
        <Carousel slides={bottom_banners} fit={"contain"}></Carousel>
      </section>

      {/* blogs */}
      <section
        id="blogs"
        className="sm:px-20 2xl:px-32 pb-20 sm:mx-32 sm:mt-32"
      >
        <h1 className="heading">
          Living Life <span className="primary_color">Outside</span>
        </h1>
        <div className="blogs_wrapper mt-10">
          {blogs.map((blog) => (
            <Link
              to={"/blogs/" + blog.slug}
              className="blog_card"
              key={blog.id}
            >
              <img src={blog.image} alt="" />
              <div className="bottom">
                <small>{blog.published_on}</small>
                <h2>{blog.title}</h2>
                {/* <p dangerouslySetInnerHTML={{ __html: blog.content_html }}></p> */}
              </div>
            </Link>
          ))}
        </div>
        <div className="flex_justify_end mt-10">
          <Link to="blogs">
            <button className="view_all_btn">View all in blog</button>
          </Link>
        </div>

        <div className="blogs_wrapper mt-10">
          {pressArticles.map((article) => (
            <a
              target="_blank"
              href={article.url}
              className="blog_card"
              key={article.id}
            >
              <img src={article.image} alt="" />
              <div className="bottom">
                <h2>{article.title}</h2>
              </div>
            </a>
          ))}
        </div>
        <div className="flex_justify_end mt-10">
          <Link to="press">
            <button className="view_all_btn">View all in press</button>
          </Link>
        </div>
      </section>

      <section id="videos" className="sm:px-20 2xl:px-32 pb-20">
        <h1 className="heading">Videos</h1>
        <div className="videos_wrapper mt-10 py-10 sm:py-20 px-5 sm:px-16">
          {videos.map((video) => (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${video.youtube_id}?controls=0`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              key={video.youtube_id}
            ></iframe>
          ))}
        </div>
      </section>
    </Fragment>
  );
}

export default Home;
